import { render, staticRenderFns } from "./CorteCajaComponent.vue?vue&type=template&id=38622154&"
import script from "./CorteCajaComponent.vue?vue&type=script&lang=js&"
export * from "./CorteCajaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports